import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import useMonthlyEvolutionServices from './hooks/useMonthlyEvolutionServices';

export const MonthlyEvolutionServices = () => {
    const { chartConfig } = useMonthlyEvolutionServices();

    return (
        <ChartContainer
            title={"Evolução do Total de Atendimento no Ano"}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={450}
        />
    );
};
